import React from "react";
import { ListGroupItem, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StudentStatus from "../Student/StudentStatus";
import moment from "moment";

const TeacherModule = (props) => {
  let mappedStatus;
  let mappedTime;

  if (props.showStatus && props.module.students.length > 0) {
    mappedStatus = (
      <StudentStatus
        className=""
        status={props.module.students[0].status}
      ></StudentStatus>
    );
    mappedTime = (
      <div className="small mw-100 mt-1 text-right" title="Senast körd">
        <FontAwesomeIcon icon="clock" className="text-secondary" />
        &nbsp;
        {moment(props.module.students[0].lastRun).format("YY-MM-DD HH:mm")}
      </div>
    );
  }
  return (
    <ListGroupItem>
      <Button
        className="m-0 p-0 me-2"
        style={{ marginLeft: "-20px" }}
        size="sm"
        color="link"
        title="Starta kursen"
        onClick={(e) => {
          props.runModule(
            props.courseId,
            props.module.moduleId,
            props.module.url,
            props.module.moduleType,
            props.module.isFinalExam && props.module.isGy25
          );
        }}
      >
        <FontAwesomeIcon icon="play-circle" size="2x" />
      </Button>
      {props.module.name}

      <Button
        size="sm"
        color="link"
        disabled={props.disabled}
        className={props.showResult ? "float-end" : "d-none"}
        title={
          props.disabled
            ? "Det finns inga resultat ännu"
            : "Se alla resultat för denna modul"
        }
        onClick={(e) => {
          props.navigateToResult(props.courseId, props.module.courseModuleId);
        }}
      >
        <FontAwesomeIcon icon="poll" size="2x" />
      </Button>
      {mappedStatus}
      {mappedTime}
    </ListGroupItem>
  );
};

export default TeacherModule;
